
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreatePushNotificationTokenDtoFormGroup() {
return new FormGroup({
    token: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
})
;
}
      